import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/signature`;

export const ROUTE: RouteDefinition = `${baseRoute}/signature`;

export const URL = (): RouteDefinition => `${baseRoute}/signature`;
